import { TblCol } from '../../../../core/table/table.types';
import { tblSpecAddColumn } from '../../../../core/table/spec';
import { TblViewSpec } from '../../../../core/table/table-view.types';

export type MonitorDefaultsColKey =
    | ''
    | 'Active'
    | 'Alert'
    | 'ConfigName'
    | 'ConfigType'
    | 'IntervalTxt'
    | 'LookbackTxt';

export function monitorDefaultsColumnSpec(): Map<MonitorDefaultsColKey, TblCol> {
    const map = new Map<MonitorDefaultsColKey, TblCol>();
    tblSpecAddColumn<MonitorDefaultsColKey>(map, 'Active', { title: 'Active' });
    tblSpecAddColumn<MonitorDefaultsColKey>(map, 'Alert', { title: 'Alerts' });
    tblSpecAddColumn<MonitorDefaultsColKey>(map, 'ConfigName', { title: 'Name' });
    tblSpecAddColumn<MonitorDefaultsColKey>(map, 'ConfigType', { title: 'Type' });
    tblSpecAddColumn<MonitorDefaultsColKey>(map, 'IntervalTxt', { title: 'Fails After' });
    tblSpecAddColumn<MonitorDefaultsColKey>(map, 'LookbackTxt', { title: 'Lookback Range' });
    return map;
}

export function monitorDefaultsDefaultView(): TblViewSpec {
    return {
        key: '0',
        title: 'Default',
        sections: [
            { title: 'Status', cols: ['Active', 'Alert'] },
            { title: 'Config', cols: ['ConfigName', 'ConfigType', 'IntervalTxt', 'LookbackTxt'] },
        ],
        sortby: 'ConfigName',
    };
}
